export default "__VITE_ASSET__DJdpHl0Q__"